import { useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@eti/utils';
import { useSiteContext } from '@eti/providers';
import { buildProductGAEvent, getTravelersWithoutInfants } from '../common/utils/productGATrackingUtil';
const CART_EVENT = {
  ADD: 'add_to_cart',
  REMOVE: 'remove_from_cart'
};
export const useProductGADataLayer = ({
  productId,
  productCode,
  productName,
  priceRaw,
  productPosition,
  layoutType,
  travelers,
  shouldEnableAddToCartButton,
  isSelected
}) => {
  const {
    siteCurrency
  } = useSiteContext();
  const {
    pathname
  } = useLocation();
  const isInCartRef = useRef(Boolean(isSelected));
  const pushProductGAEvent = useCallback((event, overrideFields) => {
    const inputFields = {
      productId,
      productCode: productCode !== null && productCode !== void 0 ? productCode : '',
      productName,
      priceRaw,
      quantity: getTravelersWithoutInfants(travelers),
      index: productPosition,
      layoutType,
      shouldEnableAddToCartButton,
      ...overrideFields
    };
    const productGAEvent = buildProductGAEvent(event, inputFields, {
      siteCurrency,
      pathname
    });
    analytics.pushEntryToDataLayer({
      ecommerce: null
    });
    analytics.pushEntryToDataLayer(productGAEvent);
  }, [siteCurrency, pathname, productId, productCode, productName, priceRaw, productPosition, layoutType, travelers, shouldEnableAddToCartButton]);
  const sendAddToCartGAEvent = useCallback(overrideFields => {
    if (isInCartRef.current) {
      return;
    }
    isInCartRef.current = true;
    pushProductGAEvent(CART_EVENT.ADD, overrideFields);
  }, [pushProductGAEvent]);
  const sendRemoveFromCartGAEvent = useCallback(overrideFields => {
    if (!isInCartRef.current) {
      return;
    }
    isInCartRef.current = false;
    pushProductGAEvent(CART_EVENT.REMOVE, overrideFields);
  }, [pushProductGAEvent]);
  const sendCartGAEvent = useCallback((value, overrideFields) => {
    if (value === 'true') {
      sendAddToCartGAEvent(overrideFields);
    } else {
      sendRemoveFromCartGAEvent(overrideFields);
    }
  }, [sendAddToCartGAEvent, sendRemoveFromCartGAEvent]);
  return {
    sendCartGAEvent
  };
};
//# sourceMappingURL=useProductGADataLayer.js.map